import { cookie } from '@pdrj/pmi-iqos-shared-react'

export default class IqospherePrize {
  constructor(api) {
    this.api = api
  }

  getPrize = async (productid, variantid) => {
    const res = await this.api.get(
      `/iqosphere/prizes/${productid}${variantid ? '/' + variantid : ''}`,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('getPrize')
      }
    )
    return res
  }

  getPrizeBySeoName = async seoname => {
    const res = await this.api.get('/iqosphere/prizes/', {
      params: { ...(seoname && { seoname }) },
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getPrize')
    })
    return res
  }

  getPrizes = async (categoryid = '') => {
    const res = await this.api.get('/iqosphere/prizes', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      params: { ...(categoryid && { categoryid }) },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('getPrizes')
    })
    return res
  }

  getPrizesCampaign = async (campaigncode = '') => {
    const res = await this.api.get('/iqosphere/prizes', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      params: { ...(campaigncode && { campaigncode }) },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('getPrizes')
    })
    return res
  }

  getOrderPrize = async (id, line) => {
    const res = await this.api.get(`/iqosphere/prizes/order/${id}`, {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      params: { t: new Date().getTime(), ...(line && { isPrizeId: true }) },
      mock: this.api.getMock('getOrderPrize')
    })
    return res
  }

  confirmAddress = async (data, ignoreAddressValidation = false) => {
    const res = await this.api.post(
      `/iqosphere/prizes/confirmAddress?b=${ignoreAddressValidation}`,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('confirmAddress'),
        data
      }
    )
    return res
  }

  getSpinWheelStatus = async campaignCode => {
    const res = await this.api.get(
      `/iqosphere/prizes/status?campaignCode=${campaignCode}`,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('getSpinWheelStatus')
      }
    )
    return res
  }

  spinWheel = async (campaignCode, action, mission) => {
    const res = await this.api.post('/iqosphere/prizes/spin', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('spinWheel'),
      data: {
        campaignCode,
        action,
        ...(mission && { mission })
      }
    })
    return res
  }
}
